import React from "react";

/**
 * Guards the WebGL canvas. If Three.js fails (no WebGL / GPU blocklist),
 * the login page still renders with its cinematic image + CSS VFX layers.
 */
export default class CanvasBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch(error) {
        console.error("Hero3D canvas failed, falling back to CSS VFX", error);
    }
    render() {
        if (this.state.failed) return this.props.fallback || null;
        return this.props.children;
    }
}
